import { render } from "./VerticalTab.vue?vue&type=template&id=59b1e100&scoped=true"
import script from "./VerticalTab.vue?vue&type=script&lang=js"
export * from "./VerticalTab.vue?vue&type=script&lang=js"

import "./VerticalTab.vue?vue&type=style&index=0&id=59b1e100&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b1e100"]])

export default __exports__